import React from 'react';
import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './CreativeCardData.css';
import cardCss from '../creativeCard/CreativeCard.css';

import { CreativeMultiValuedDimensionsType, CreativeType } from '../../types';
import OSIcon from '../OSIcon/OSIcon';
import { AutoCompleteOptionType } from '../../../components/molecules/autocompleteTypes';
import CopyToClipboardButton from '../../../components/molecules/CopyToClipboardButton';
import { trackMixpanelEvent } from '../../../utils/general';
import MetricField from './metricField/MetricField';
import { CardSections } from '../../consts';

const COPY_TO_CLIPBOARD_TEXT = 'STATIC.PAGES.CREATIVE_GALLERY.COPY_TO_CLIPBOARD';

const CreativeCardData = ({
    osList = [],
    metrics = {},
    cohorts = {},
    loadingSections = [],
    selectedMetrics = [],
    url = '',
    selectedCohorts = [],
    layout = '',
    cardStyle = {},
}) => {
    const isAllMetricsLoading = loadingSections.includes(CardSections.METRICS);
    const shouldDisplayCohort = !!selectedCohorts.length && !isAllMetricsLoading;

    return (
        <div className={css.container} style={cardStyle}>
            {!!selectedMetrics.length && (
                <>
                    <div className={classNames(css.metrics, cardCss.scrollableSection, css[layout])}>
                        {isAllMetricsLoading ? (
                            <div>
                                <Skeleton className={css.metricSkeleton} />
                                <Skeleton className={css.metricSkeleton} />
                            </div>
                        ) : (
                            selectedMetrics.map(({ value, label, shortLabel }) =>
                                metrics[value] === undefined ? (
                                    <Skeleton key={value} className={css.metricSkeleton} />
                                ) : (
                                    <MetricField
                                        key={value}
                                        value={value}
                                        label={label}
                                        shortLabel={shortLabel}
                                        data={metrics}
                                        showColon
                                    />
                                )
                            )
                        )}
                    </div>
                    {shouldDisplayCohort && <div className={css.divider} />}
                </>
            )}
            {shouldDisplayCohort && (
                <div className={classNames(css.metrics, cardCss.scrollableSection, css.cohortsSection, css[layout])}>
                    {selectedCohorts.map(({ value, label }) =>
                        cohorts[value] === undefined ? (
                            <Skeleton key={value} className={css.metricSkeleton} />
                        ) : (
                            <MetricField key={value} value={value} label={label} data={cohorts} showColon cohort />
                        )
                    )}
                </div>
            )}
            <div className={classNames(css.bottomRow, css[layout])}>
                <div className={css.osListContainer}>
                    {loadingSections.includes(CardSections.MULTI_VALUED_DIMENSIONS) ? (
                        <Skeleton variant="circular" className={css.osIconContainer} />
                    ) : (
                        osList.map(osValue => (
                            <div key={osValue} className={css.osIconContainer}>
                                <OSIcon osValue={osValue} className={css.osIcon} />
                            </div>
                        ))
                    )}
                </div>
                <CopyToClipboardButton
                    textToCopy={url}
                    preCoyIconName="link"
                    tooltip={COPY_TO_CLIPBOARD_TEXT}
                    onClick={() => trackMixpanelEvent('Creative Gallery', 'copy link')}
                />
            </div>
        </div>
    );
};

CreativeCardData.propTypes = {
    osList: CreativeMultiValuedDimensionsType.osList,
    metrics: CreativeType.metrics,
    cohorts: CreativeType.cohorts,
    loadingSections: PropTypes.arrayOf(PropTypes.string),
    selectedMetrics: PropTypes.arrayOf(AutoCompleteOptionType),
    url: PropTypes.string,
    selectedCohorts: PropTypes.arrayOf(AutoCompleteOptionType),
    layout: PropTypes.string,
    cardStyle: PropTypes.objectOf(PropTypes.any),
};

export default CreativeCardData;
